import { FormArray, FormControl, FormGroup } from '@angular/forms';
import {
  OlxAdvertActionPayload,
  OlxAdvertiserType,
  OlxAdvertItem,
  OlxLocation,
} from '../../../../../modules/crm/power-olx-v2/interfaces/power-olx-v2.interface';
import { PriceForm } from '../../../../price-editor/price-editor.interface';

export interface OlxAdvertActionDraft {
  advert: OlxAdvertActionPayload;
  selectedLocation?: OlxLocation;
}

export interface AdvertForm {
  title: FormControl<string | null>;
  description: FormControl<string | null>;
  category_id: FormControl<number | null>;
  contact: FormGroup<ContactForm>;
  location: FormControl<OlxLocationForm | null>;
  images: FormControl<{ url: string }[] | null>;
  price?: FormGroup<PriceForm>;
  advertiser_type: FormControl<OlxAdvertiserType | null>;
  attributes?: FormArray<FormGroup<AttributeForm>>;
  auto_extend_enabled: FormControl<boolean | null>;
}

export interface AttributeForm {
  code: FormControl<string | null>;
  value?: FormControl<string | null>;
  values?: FormControl<string[] | null>;
}

interface ContactForm {
  name: FormControl<string | null>;
  phone: FormControl<string | null>;
}

export interface OlxLocationForm {
  city_id: number | null;
  district_id: number | null;
}

export interface AdvertActionPayload {
  action_type: AdvertActionType;
  channel_id: string;
  advert?: OlxAdvertItem;
  planner_id?: string;
}

export enum AdvertActionType {
  Create,
  Update,
}

export const ADVERTISER_TYPE_VALUES = [
  { value: 'private', label: 'private_person' },
  { value: 'business',  label: 'business' },
];
